import { render, staticRenderFns } from "./requestPasswordReset.vue?vue&type=template&id=93731d64&scoped=true"
import script from "./requestPasswordReset.vue?vue&type=script&lang=js"
export * from "./requestPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./requestPasswordReset.vue?vue&type=style&index=0&id=93731d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93731d64",
  null
  
)

export default component.exports